import token, { tokenToVars } from '../token';
import Badge from './badge';

export { Badge };
export default tokenToVars(Badge, token);
